module.exports = __webpack_public_path__ + "img/banner-left-1280.824dd889.png";